// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapped-icon_wrapper__+lvFN","red":"wrapped-icon_red__ctFso","green":"wrapped-icon_green__XGWbR"};